import { ArgumentValidator } from "./argument-validator";

export class NameOf {

    public static property<T extends Record<string, any>, K extends keyof T>(obj: T, selector: (x: T) => T[K]): string {

        ArgumentValidator.notNullOrEmpty(obj, 'obj');
        ArgumentValidator.notNullOrEmpty(selector, 'selector');
    
        let propertyName: string | undefined;
    
        const proxy = new Proxy({} as T, {
            get(_, key) {
                if (typeof key === "string") {
                    propertyName = key;
                }
                return undefined;
            }
        });
    
        selector(proxy);
    
        return propertyName ?? "";
    }
}